import React, { Fragment } from 'react';
import { get } from 'lodash';
import { Radio } from 'core/controls';
import { Translate, TranslateHTML, withTranslate } from 'core/translate';
import { combineClassNames } from 'core/css';

const getOptionDescription = option =>
  option.formattedConfig || option.shortCFD || option.description;

const OptionConflictRadio = props => {
  const { analyticsKey, option, selection, onChange } = props;
  const { longCFD, description, discountedPriceTotal, displayedMsrp } = option;
  const headerClassName = combineClassNames([
    'option-conflict__radio-subheader',
    longCFD ? '' : 'option-conflict__radio-subheader--without-cfd'
  ]);
  return (
    <div key={option.id} className="option-conflict__option-group">
      <Radio
        checked={selection === option}
        onChange={() => onChange(option)}
        className="option-conflict__radio-label"
        analyticsKey={analyticsKey}>
        <div>
          <div className={headerClassName}>
            <span dangerouslySetInnerHTML={{ __html: description }} />{' '}
            <span
              dangerouslySetInnerHTML={{
                __html: discountedPriceTotal || displayedMsrp
              }}
              className="modal-body__label"
            />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: longCFD }}
            className="choice-item-desc"
          />
        </div>
      </Radio>
    </div>
  );
};

const OptionConflictWithUserSelection = props => {
  const { translate, option, selection, conflictConfig, onChange } = props;

  const userSelectionOptions = get(
    conflictConfig,
    'config.TOGGLE_CHECK.userChoiceOptions',
    []
  );

  return (
    <Fragment>
      <div className="modal-body__subheader">
        <TranslateHTML
          value="conflict.header.choice"
          description={getOptionDescription(option)}
        />
      </div>
      <div>
        <span className="modal-body__label option-conflict__label">
          <Translate value="component.options.add" />
        </span>

        <div className="choice-contents">
          {userSelectionOptions.map(option => (
            <OptionConflictRadio
              key={option.id}
              option={option}
              selection={selection}
              analyticsKey={translate('configuration.assistant')}
              onChange={onChange}
            />
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default withTranslate(OptionConflictWithUserSelection);
